import { Assessment } from "../../../../../components/Profile/ProfileTabPages/Assessment";
import { useUser } from "../../../../../features/User/userQueries";

export default function PersonalReport({ isPersonal, expanded }) {
  const { data: user } = useUser();
  return <Assessment expanded={expanded} isPersonal={isPersonal} canRequestFeedback={true} userId={user._id} />;
}
